<template>
  <el-dialog
    title="录入数据"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="80%"
  >
    <el-form
      class="filters"
      ref="form"
      :model="formSearch"
      inline
      label-width="50px"
      :rules="rules"
    >
      <el-form-item label="日期" class="date-wrap" prop="timeRange">
        <el-date-picker
          v-model="formSearch.timeRange"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          style="width: 320px"
          :disabled="['IS_EDITING', 'IS_VIEW'].includes(type)"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="产品" prop="afid">
        <product-select
          :isDefault="true"
          :value.sync="formSearch.afid"
          placeholder="请选择产品"
          @change="handerAfid"
          popper-class="BI-select BI-select-product"
          :disabled="['IS_EDITING', 'IS_VIEW'].includes(type)"
        >
        </product-select>
      </el-form-item>
      <el-form-item label="地区" prop="geo">
        <el-select
          v-model="formSearch.geo"
          filterable
          :filter-method="filterMethod"
          clearable
          :disabled="['IS_EDITING', 'IS_VIEW'].includes(type)"
          placeholder="请选择"
        >
          <el-option
            v-for="item in countryList"
            :label="item.name"
            :value="item.paramGeo"
            :key="item.paramGeo"
          >
            <template>
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                item.geo
              }}</span>
            </template>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="渠道" prop="mediaSource">
        <el-select
          class="multiple-select"
          v-model="formSearch.mediaSource"
          placeholder="全部渠道"
          clearable
          filterable
          collapse-tags
          multiple
          style="width: 250px"
          :disabled="['IS_EDITING', 'IS_VIEW'].includes(type)"
        >
          <el-option
            v-for="item in mediaList"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="loadData()">筛选</el-button>
      </el-form-item>
    </el-form>

    <el-table
      id="table"
      :data="tableData"
      v-loading="loading"
      :max-height="tableHeight"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
      ref="table"
    >
      <el-table-column
        v-for="(item, i) in column"
        :prop="item.key"
        :label="item.name"
        :key="i"
        align="center"
        :width="item.width"
      >
      </el-table-column>
      <el-table-column label="渠道/推广数据（小数点后两位）">
        <template slot-scope="{ row }">
          <div
            v-for="item in row.list"
            :key="item.mediaSource"
            style="display: flex; margin-bottom: 8px"
          >
            <span style="width: 150px; text-align: left; margin-right: 12px"
              >{{ item.mediaSource }}：</span
            >
            <el-radio-group
              v-model="item.currency"
              style="margin-right: 8px"
              size="mini"
              @input="row.cost = 0"
            >
              <el-radio-button label="0">$</el-radio-button>
              <el-radio-button label="1">￥</el-radio-button>
            </el-radio-group>
            <el-input-number
              v-model="item.cost"
              size="mini"
              :precision="2"
              :disabled="type === 'IS_VIEW'"
              style="width: 150px"
            ></el-input-number>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button
        type="primary"
        :disabled="!tableData.length || type == 'IS_VIEW'"
        @click="saveOrSubmitHandle(1)"
        >提交入库</el-button
      >
      <el-button
        type="primary"
        :disabled="!tableData.length || type == 'IS_VIEW'"
        @click="saveOrSubmitHandle(0)"
        >保存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { getDetailList, saveRecord } from "@/api/popuManual.js";
import { changeshortcutclass } from "@/utils/tool";
import { getMedias } from "@/api/lt-check.js";
import moment from "moment";

export default {
  props: {},
  components: {},
  data() {
    var checkDate = (rule, value, callback) => {
      if (!value || !value.length) {
        return callback(new Error("请选择日期"));
      }

      callback();
    };

    return {
      type: "IS_EDITING",
      loading: false,
      dialogVisible: false,
      tableData: [],
      countryList: [],
      copyCountryList: [],
      mediaList: [],
      formSearch: {
        timeRange: [
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 6),
          new Date(),
        ],
        // dateStart: new Date(new Date().getTime() - 3600 * 1000 * 24 * 6),
        // dateEnd: new Date(),
        geo: "",
      },
      total: 0,
      tableHeight: window.innerHeight - 400,
      rules: {
        // dateStart: [],
        // dateEnd: [],
        timeRange: [{ required: true, validator: checkDate, trigger: "blur" }],
        afid: [{ required: true, message: "请选择产品", trigger: "blur" }],
        geo: [{ required: true, message: "请选择地区", trigger: "blur" }],
        mediaSource: [
          { required: true, message: "请选择渠道", trigger: "blur" },
        ],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "当天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("当天", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一周", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一个月", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近2个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近2个月", picker.$el);
              }, 0);
            },
          },
        ],
        disabledDate: function (date) {
          let deff = 90 * 24 * 60 * 60 * 1000;
          return (
            new Date().getTime() - date.getTime() <= 0 ||
            new Date().getTime() - deff > date.getTime()
          );
        },
        onPick: function () {},
      },
    };
  },
  computed: {
    column() {
      return [
        { key: "dateStr", name: "日期", width: 150 },
        { key: "productName", name: "产品名称", width: 200 },
        { key: "afid", name: "唯一标识", width: 200 },
        { key: "geo", name: "地区", width: 200 },
      ];
    },
  },
  async mounted() {
    const timer = setInterval(() => {
      if (this.formSearch.afid) {
        clearInterval(timer);
        this.$store.dispatch("getCountryList", {
          afid: this.formSearch.afid,
          cb: (result) => {
            this.countryList = result;
            this.copyCountryList = result;
          },
        });
      }
    }, 200);
    const { code, mediaList } = await getMedias();
    if (code !== "0000") return;
    this.mediaList = mediaList;
  },
  methods: {
    // currencyInputHandle(v, row) {
    //   if (!row.cost) return;

    //   let { cost, rate } = row;
    //   cost = parseFloat(cost);
    //   rate = parseFloat(rate);

    //   // 人民币转美元
    //   if (v == 0) {
    //     cost = cost / rate;
    //   }
    //   // 美元转人民币
    //   if (v == 1) {
    //     cost = cost * rate;
    //   }

    //   row.cost = cost.toFixed(2);
    // },
    async saveOrSubmitHandle(dataStatus = 0) {
      try {
        this.loading = true;
        const { recordId: id, afid, geo } = this.formSearch;
        const detailList = this.tableData.map(({ dateStr, list }) => ({
          dateStr,
          list: list.map((child) => {
            child.cost = child.cost ? child.cost + "" : child.cost || 0;
            return child;
          }),
        }));
        const { code, msg } = await saveRecord({
          id,
          afid,
          geo,
          dataStatus,
          detailList,
        });
        if (code !== "0000") return this.$message.error(msg);

        if (dataStatus === 0) {
          this.$message.success("保存成功");
          this.dialogVisible = false;
        } else {
          this.$message.success("入库成功");
          this.dialogVisible = false;
        }

        this.$emit("refresh");

        // eslint-disable-next-line no-empty
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    filterMethod(value) {
      this.countryList = this.copyCountryList.filter((item) => {
        let valueStr = String(value);
        return (
          item.paramGeo.toLowerCase().includes(valueStr.toLowerCase()) ||
          item.name.toLowerCase().includes(valueStr.toLowerCase()) ||
          item.geo.toLowerCase().includes(valueStr.toLowerCase())
        );
      });
    },
    handerAfid(e) {
      this.formSearch.geo = [];
      this.$store.dispatch("getCountryList", {
        afid: e,
        cb: (result) => {
          this.countryList = result;
        },
      });
    },
    showModal(type, row) {
      if (!row) {
        this.formSearch = this.$options.data().formSearch;
      } else {
        const {
          afid,
          geo,
          mediaSource,
          id: recordId,
          dateStart,
          dateEnd,
        } = row;
        this.formSearch = {
          ...this.formSearch,
          afid,
          geo,
          mediaSource: mediaSource.split(","),
          recordId,
          timeRange: [
            moment(dateStart, "YYYYMMDD"),
            moment(dateEnd, "YYYYMMDD"),
          ],
          // dateStart: moment(dateStart, "YYYYMMDD"),
          // dateEnd: moment(dateEnd, "YYYYMMDD"),
        };
      }
      this.type = type;
      this.tableData = [];
      this.dialogVisible = true;

      this.$nextTick(() => {
        if (type) this.loadData();
      });
    },
    async loadData() {
      try {
        await this.$refs.form.validate();
        this.loading = true;

        const [dateStart = "", dateEnd = ""] = this.formSearch.timeRange || [];

        const { code, msg, data } = await getDetailList({
          ...this.formSearch,
          dateStart: moment(dateStart).format("YYYYMMDD"),
          dateEnd: moment(dateEnd).format("YYYYMMDD"),
          mediaSource: this.formSearch.mediaSource.join(","),
        });
        if (code !== "0000") return this.$message.error(msg);
        this.tableData = data;
        // eslint-disable-next-line no-empty
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.filters {
  margin-bottom: 10px;
}
</style>
